module.exports = __webpack_public_path__ + "img/qris.affef811.webp";